module.exports = __webpack_public_path__ + "img/DSC06875.bb4aadf5.jpg";